import React, { useEffect } from 'react';
import { Messages } from 'constants/Messages';
import { cemServiceClient } from 'hooks/use-cem-service-api';
import { useAppDispatch } from 'store/app/hooks';
import { envProperties } from '../../../utils/EnvironmentProperties';
import { showErrorSnackbar } from '../snackbar/Snackbar.slice';
import { fetchClientsData, fetchRoleFeatures } from './Slices/Cem.slice';
import { setUserRoleFeatures } from '../../../pages/users/users.slice';
import { ErrorCodesAPI } from 'constants/ErrorCodes';

const CemAuthorization = (props: any): React.ReactElement => {
	const dispatch = useAppDispatch();
	const insightAppId = envProperties.authentication.clientId;

	useEffect(() => {
		const fetchAuthorizationData = async () => {
			const response = await cemServiceClient.authorization3_Get(`Level eq 'Application'`);
			if (response) {
				const features = Object.values(response)
					.flatMap(roleArr => roleArr.map(role => role.features || []))
					.flat();
				const userFeatures = features.map(feat => feat.toLowerCase());
				dispatch(setUserRoleFeatures(userFeatures));
			} else {
				showErrorSnackbar(
					dispatch,
					`${ErrorCodesAPI.CemUserAuthorizationsFetchingError} - ${Messages.EXCEPTION_FOR_FETCHING_AUTHORIZATION}`
				);
			}
		};
		fetchAuthorizationData()
			.catch(() => {
				showErrorSnackbar(
					dispatch,
					`${ErrorCodesAPI.CemUserAuthorizationsFetchingError} - ${Messages.EXCEPTION_FOR_FETCHING_AUTHORIZATION}`
				);
			});
	}, [dispatch]);

	useEffect(() => {
		dispatch(fetchClientsData());
		dispatch(fetchRoleFeatures(insightAppId));
	}, [dispatch]);

	return (
		<div>
			{props.children}
		</div>
	);
};
export default CemAuthorization;
